/*
 * Nordbjærg's product slider (snippets/nb-product-slider.liquid).
 * The track is a native horizontal scroller with scroll snapping; this script only wires the arrow
 * buttons: each click moves one "page" of cards, and an arrow hides when there is nothing more
 * that way. Safe to load more than once and for several sliders on a page.
 */
(function () {
  function setup(slider) {
    if (slider.dataset.ready) return;
    slider.dataset.ready = '1';
    var track = slider.querySelector('[data-nb-slider-track]');
    var prev = slider.querySelector('[data-nb-slider-prev]');
    var next = slider.querySelector('[data-nb-slider-next]');
    if (!track || !prev || !next) return;
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var atStart = track.scrollLeft <= 4;
      var atEnd = track.scrollLeft >= max - 4;
      // An arrow that hides while it has focus would drop focus to the page: hand it to the other arrow
      if (atEnd && !atStart && document.activeElement === next) prev.focus();
      if (atStart && !atEnd && document.activeElement === prev) next.focus();
      prev.hidden = atStart;
      next.hidden = atEnd;
    }

    function move(direction) {
      var item = track.querySelector('.product-item');
      var step = track.clientWidth;
      if (item) {
        // A whole number of cards, so the next page starts on a card edge
        var width = item.getBoundingClientRect().width;
        step = Math.max(width, Math.floor(track.clientWidth / width) * width);
      }
      track.scrollBy({ left: direction * step, behavior: reduce.matches ? 'auto' : 'smooth' });
    }

    prev.addEventListener('click', function () { move(-1); });
    next.addEventListener('click', function () { move(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-nb-slider]'), setup);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  // Theme editor: set up sliders in sections that are added or re-rendered
  document.addEventListener('shopify:section:load', init);
})();
